<div class="bina-wrapper">
  <div class="bina-header">
    <div class="bina-header-text">
      {{ "BINA_CLASSIFIER" | translate }}
    </div>
    <div class="bina-header-close" (click)="close.emit()">×</div>
  </div>

  <div class="bina-content">
    <div class="bina-input-form" *ngIf="!isShowBinaTitleHeader; else BinaTitleHeader">
      <form (ngSubmit)="classify()">
        <textarea
          #termControlInput
          type="text"
          class="form-control bina-input-textarea"
          id="termControl"
          name="termControl"
          control-wrapper
          [formControl]="termControl"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F{500}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maskSkipEnter]="true"
          [rows]="2"
          [placeholder]="'BINA_PLACEHOLDER' | translate"
          (keydown)="classifyInputPressKey($event)"
        ></textarea>

        <button type="submit" class="bina-input-button">{{ "CLASSIFY" | translate }}</button>
      </form>
    </div>

    <ng-template #BinaTitleHeader>
      <div class="bina-title-header">
        <p class="bina-title-header__text">{{ this.termControl.value }}</p>
        <img
          class="bina-title-header__edit"
          [ngClass]="{ disabled: isLoading }"
          src="assets/icons/edit_gray.svg"
          (click)="showBinaTitleHeader(false)"
        />
      </div>
    </ng-template>

    <ng-container *ngIf="!isClassifying">
      <div class="bina-input-placeholder">
        <img src="assets/icons/icon_earth_placeholder.svg" />
      </div>
    </ng-container>

    <ng-container *ngIf="isClassifying">
      <div class="bina-proposals">
        <div class="bina-proposals-header"></div>

        <div class="bina-proposals-stack" [ngClass]="{ 'bina-proposals-stack-cut': isFooterHover }" #scrollingContainer>
          <div class="bina-proposals-stack-items">
            <ng-container *ngFor="let item of treeData">
              <bina-proposal
                [htsCode]="item.hts"
                [firstText]="fullDescription(item.hts)"
                [secondText]="hint(item.hts) | translate"
                [options]="item.children"
                [selectedHTS]="selectedHTS"
                [isShowInsertCode]="isShowInsertCode"
                [isShowAddToCatalog]="isShowAddToCatalog"
                [isShowPath]="isShowPath(item.hts)"
                (optionClick)="handleChild($event)"
                (htsInsert)="onHtsInsert(item.hts)"
                (addHtsToCatalog)="onAddHtsToCatalog(item.hts)"
                (subGroupClick)="handlePath($event)"
              ></bina-proposal>
            </ng-container>

            <ng-container *ngIf="isTreeHasAnyFullHTS && isShowClassifierEndOptions">
              <div class="bina-proposals-stack-items-end-container">
                <p class="bina-proposals-stack-items-end-container__title">
                  {{ "BINA_CLASSIFIER_END_OPTIONS.HEADER" | translate }}
                </p>

                <div class="bina-proposals-stack-items-end-container__options">
                  <div class="bina-proposals-stack-items-end-container__options-item" (click)="onClassifyAnotherItem()">
                    {{ "BINA_CLASSIFIER_END_OPTIONS.CLASSIFY_ANOTHER_ITEM" | translate }}
                  </div>

                  <div class="bina-proposals-stack-items-end-container__options-item" (click)="onFileEntrySummary()">
                    {{ "BINA_CLASSIFIER_END_OPTIONS.FILE_ENTRY_SUMMARY" | translate }}
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="isShowEmptyResult">
              <div class="bina-proposals-stack-items-empty">
                {{ "BINA_PLACEHOLDER_EMPTY_RESULT" | translate }}
              </div>
            </ng-container>
          </div>
        </div>

        <div class="bina-loader" *ngIf="isLoading">
          <div class="bina-loader-container">
            <img class="bina-loader-bg" src="/assets/icons/icon_bina_bg.svg" />
            <img class="bina-loader-bar" src="/assets/icons/icon_bina_bar.svg" />
          </div>
        </div>
        <border-spinner *ngIf="!isLoading && isChildLoading" centered="true"></border-spinner>
      </div>
    </ng-container>

    <div
      class="bina-input-footer"
      [ngClass]="{ 'disclaimer-open': isFooterHover }"
      [title]="!isFooterHover ? ('AI_HTS_CLASSIFIER_DISCLAIMER_FULL' | translate) : ''"
      (mouseover)="footerOver()"
      (mouseout)="footerOut()"
    >
      <span>{{ (isFooterHover ? "AI_HTS_CLASSIFIER_DISCLAIMER_FULL" : "AI_HTS_CLASSIFIER_DISCLAIMER") | translate }}</span>
    </div>
  </div>
</div>
